module.exports = __webpack_public_path__ + "dist/assets/f58f3f542a746f99049fc86a1a8c0929.svg";